import { useQuery } from "@tanstack/react-query";
import { getItalianStory } from "../index";

const useItalianStory = () => {
    return useQuery({
        queryKey: ["italian-story"],
        queryFn: () => getItalianStory(),
        refetchOnWindowFocus: false,
    });
};

export default useItalianStory;
